import { useEffect, useState } from 'react';

//components
import { Card } from 'primereact/card';

//api
import { TemplateService } from "../../../service/template-service";

        

const TemplateCard = ()=>{
    const [templates,setTemplates]= useState(0)

    useEffect(()=>{
        const fetchProjects = ()=>{
            TemplateService.getAllTemplates(
                (data)=>{
                    setTemplates(data.count)
                },
                (error) => {
                    console.error("Errore durante il recupero dei template: ", error);
                    
                }
            )
        }
        fetchProjects()
    },[])

    return (
        <div>
            <Card title="Template" className='dashboard__TemplateWrapper'>
                <div className='dashboard__CardContent'>
                    <div>
                     {templates}
                    </div>
                    <div>
                       <i className='pi pi-file'></i> 
                    </div>
                </div>
                <div className='dashboard__Link'>
                    <a href='/dashboard/template'>Vai ai template <i className='pi pi-arrow-right' ></i></a>
                </div>
            </Card>
        </div>
    )
}

export default TemplateCard